<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chaptitle1"><a id="page_xi"></a><a id="ack"></a>ACKNOWLEDGMENTS</h1>
<p class="text">I WANT TO ACKNOWLEDGE the enormous contributions of two people in writing this book:</p>
<p class="text-indent">My wife, Cynsie Kraines, often says that I have studied life and leadership, whereas she has lived life and leadership. I have learned so much from her about how value-adding leaders “really” add value. She has been the backbone and source of energy for 30 years in building our firm, The Levinson Institute, which is now part of Pariveda Solutions.</p>
<p class="text-indent">My “James Boswell” and VP, knowledge management, Robert Krock, who after 30 years knows what I am going to say before I say it, often before I even think it. Documenting the principles over the past 30 years and writing this book without Robert's contributions would have been impossible.</p>
<p class="text-indent">As many of my clients and colleagues over the years know, I have learned as much from them as they have from me. Much of this book emerged from working with Denis Turcotte, Eduardo Padilla, Mikael Gordon, Jim Allen, Karen Rosene-Montella, Fabiaan van Vrekhem, Warren Knowlton, Gerry Yonas, John Dyer, Barry Hurewitz, Brian Gifford, Zoran Veselic, Ben Duster, Rafa Ramos, Steve Jenkins, Mario Botas, Francisco Martínez Colunga, Rob Hennemuth, Nick Stanage, Anne Bakar, Ferio Pugliese, Mark Fuller, Mike Broz, Eddie Opler, and many more than can fit on this page.</p>
<p class="text-indent">Finally, I want to acknowledge and thank Bruce Ballengee, Pariveda Solutions' president and CEO, and Kerry Stover, Pariveda's COO, for incorporating and agreeing to steward the Levinson IP and its purpose: “to have a profound impact on society by bringing ‘basic laws of human nature’ into our work organizations.” For Cynsie and I now lead Levinson by Pariveda!</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_acknowledgments.vue?e751d012